import { render, staticRenderFns } from "./MainDepartment.vue?vue&type=template&id=681f373f"
import script from "./MainDepartment.vue?vue&type=script&lang=js"
export * from "./MainDepartment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports